<template>
  <div>
    <select-shop id="manageSalesHoursSelectShop" class="select-shop-container" :loadingButton="loading"  v-on:getData="getOrderShopSetting" />
    <CCard >
      <CCardBody >
        <div class="queue-config-container p-4" v-if="isQueueDisplayEnabled">
          <div class="header-section mb-4">
            <h3 class="font-weight-bold ">{{ $t('queue.settingTitle') }}</h3>
            <h5 class="text-muted">
              {{ $t('queue.settingSubtitle') }}
            </h5>
          </div>

          <CRow >
            <CCol xl="7" lg="6" md="12">
              <div  class="config-card mb-3">
                <h5 class="section-title"> <i class="fi fi-rr-settings mr-2"></i> {{ $t('queue.currentMode') }}</h5>
                <div class="segmented-control" style="pointer-events: none; opacity: 0.8;">
                  <div class="control-item" :class="{ active: displayQueue.mode === 'CUSTOMER' }">
                    <i class="fi fi-rr-users-alt mr-1"></i> {{ $t('queue.modeCustomer') }}
                  </div>
                  <div class="control-item" :class="{ active: displayQueue.mode === 'ORDER' }">
                    <i class="fi fi-rr-bell-ring mr-1"></i> {{ $t('queue.modeOrder') }}
                  </div>
                </div>
                <p class="text-warning small mt-2">   {{ $t('queue.modeChangeNote') }}</p>
     
              </div>

              <div class="config-card mb-3">
                <h5 class="section-title"><i class="fi fi-rr-picture mr-2"></i>{{ $t('queue.logoTitle') }}</h5>
                <p class="text-muted small mb-3">{{ $t('queue.logoHint') }}</p>
                
                <div class="d-flex gap-4">
                  <div class="logo-upload-group text-center pr-3">
                    <div class="upload-label mb-2">{{ $t('queue.landscape') }}</div>
                    <CButton class="logo-placeholder landscape" @click="openLogoModal('landscape')">
                      <img v-if="logoImage.landscape" :src="logoImage.landscape" />
                      <span v-else class="plus-btn"><i class="fi fi-rr-plus"></i></span>
                    </CButton>
                  </div>
                  <div class="logo-upload-group text-center">
                    <div class="upload-label mb-2">{{ $t('queue.portrait') }}</div>
                    <CButton class="logo-placeholder portrait" @click="openLogoModal('portrait')">
                      <img v-if="logoImage.portrait" :src="logoImage.portrait" />
                      <span v-else class="plus-btn"><i class="fi fi-rr-plus"></i></span>
                    </CButton>
                  </div>
                </div>
              </div>

              <div class="config-card mb-3">
                <h5 class="section-title"><i class="fi fi-rr-palette mr-2"></i>{{ $t('queue.displayTheme') }}</h5>
                
                <div class="form-group">
                  <label class="font-weight-bold mb-2">{{ $t('queue.themeColor') }}</label>
                  <div class="color-palette-grid mb-3 ">
                    <CButton v-for="c in themeColorOptions" :key="c.code" 
                      @click="setThemeColor(c)"
                      class="color-option-btn"
                      :class="{ active: selectedTheme === c.code }"
                      :style="{ backgroundColor: c.code }">
                      <i v-if="selectedTheme === c.code" class="fi fi-rr-check text-white"></i>
                    </CButton>
                    
                    <div class="custom-color-picker-wrapper">
                      <input type="color" @change="updateTheme" :value="selectedTheme" class="color-input-hidden" id="customColor" />
                      <label for="customColor" class="custom-color-label" :style="{ backgroundColor: selectedTheme }">
                        <i class="fi fi-rr-settings-sliders" style="    padding-top: 5px;"></i>
                      </label>
                    </div>
                  </div>
                    <div class="mt-0">
                  <span>{{ $t("selfCustom") }}  </span>
                  <input type="color" @change="updateTheme" :value="selectedTheme" class="theme-color-btn" />
                </div>
                  <small class="text-info">{{ $t('queue.colorHint') }}</small>
                </div>

                <hr class="my-4" />

                <CRow>
                  <CCol md="6">
                    <label class="font-weight-bold">{{ $t('queue.screenLayout') }}</label>
                    <div class="segmented-control">
                      <div class="control-item" :class="{ active: layoutType === 'landscape' }" @click="setLayout('landscape')">
                        <i class="fi fi-rr-rectangle-horizontal mr-1"></i> {{ $t('queue.tvMode') }}
                      </div>
                      <div class="control-item" :class="{ active: layoutType === 'portrait' }" @click="setLayout('portrait')">
                        <i class="fi fi-rr-rectangle-vertical mr-1"></i> {{ $t('queue.tabletMode') }}
                      </div>
                    </div>
                  </CCol>
                  <CCol md="6">
                    <label class="font-weight-bold">{{ $t('queue.displayLang') }}</label>
                    <div class="segmented-control">
                      <div class="control-item" :class="{ active: displayLanguage === 'TH' }" @click="setDisplayLanguage('TH')">ไทย (TH)</div>
                      <div class="control-item" :class="{ active: displayLanguage === 'EN' }" @click="setDisplayLanguage('EN')">English (EN)</div>
                    </div>
                  </CCol>
                </CRow>
              </div>

              <div class="config-card mb-3">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <h5 class="section-title m-0"><i class="fi fi-rr-megaphone mr-2"></i>{{ $t('queue.voiceSystem') }}</h5>
                  <div class=" d-flex align-items-center">
                    <div class="custom-control custom-switch custom-switch-md">
                      <input 
                        type="checkbox" 
                        class="custom-control-input" 
                        id="voiceSwitch" 
                        :checked="enableVoice" 
                        @change="toggleVoice"
                      >
                      <label class="custom-control-label font-weight-bold" for="voiceSwitch">
                        <span :class="enableVoice ? 'text-success' : 'text-muted'">
                          {{ enableVoice ? $t('enable') : $t('disable') }}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>

                <div v-if="enableVoice" class="voice-config-area p-3 bg-light rounded-lg">
                  <label class="small font-weight-bold text-uppercase text-muted">{{ $t('queue.voiceOrder') }}</label>
                  <div class="d-flex gap-3 mt-2">
                    <div v-for="lang in ['TH', 'EN']" :key="lang" 
                      class="voice-lang-card  mr-2"
                      :class="{ selected: voiceLanguages.includes(lang) }"
                      @click="toggleVoiceLang(lang)">
                      <img :src="`/img/languages/${lang.toLowerCase()}.png`" class="lang-flag" />
                      <span class="lang-name">{{ lang }}</span>
                      <div v-if="voiceLanguages.includes(lang)" class="order-badge">
                        {{ voiceLanguages.indexOf(lang) + 1 }}
                      </div>
                    </div>
                  </div>
                  <p v-if="voiceLanguages.length > 1" class="mt-3 mb-0 small text-success">
                    <i class="fi fi-rr-info mr-1"></i>  {{ $t('queue.voiceInfo', { lang1: voiceLanguages[0], lang2: voiceLanguages[1] }) }}
                  </p>
                </div>
              </div>

              <div class="config-card mb-3">
                <!-- ส่วนหัวพร้อมสวิตช์เลือกโหมด -->
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <h5 class="section-title m-0"><i class="fi fi-rr-apps mr-2"></i>{{ $t('queue.adTitle') }}</h5>
        
                    <!-- เปลี่ยนจาก Switch เป็น Segmented Control -->
                    <div class="segmented-control" style="width: 280px;" >
                      <div class="control-item" 
                          :class="{ active: !isVideoBanner }" 
                          @click="setVideoMode(false)">
                        <i class="fi fi-rr-picture mr-1"></i> {{$t('queue.imgMode')}}
                      </div>
                      <div class="control-item" 
                          :class="{ active: isVideoBanner }" 
                          @click="setVideoMode(true)">
                        <i class="fi fi-rr-play-circle mr-1"></i>  {{$t('queue.videoMode')}}
                      </div>
                    </div>
                  
                </div>

                <!-- กรณีเลือกโหมดวิดีโอ -->
               <div v-if="isVideoBanner" class="video-settings mt-3">
                <label class="font-weight-bold mb-2">{{ $t('queue.manageVideo') }}</label>
                <p class="text-muted small mb-3">
                  {{ $t('queue.videoDescription') }}
                </p>
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <div class="d-flex justify-content-between mb-0">
                      <label class="font-weight-bold text-dark">{{ $t('queue.landscape') }}</label>
                      <small class="text-muted" style="font-size: 11px;">1:1.33 (691x918 px)</small>
                    </div>
                    <input type="text" class="form-control mb-2" v-model="videoBanner.landscape" placeholder="YouTube URL...">
                    <div class="video-preview-wrapper border rounded-lg shadow-sm bg-dark" style="padding-top: 50%;">
                      <LazyYoutube v-if="videoBanner.landscape "
                        :src="formatYoutubeUrl(videoBanner.landscape)" :autoplay="false" :loop="true" :mute="true"
                        class="position-absolute w-100 h-100" style="top: 0; left: 0;" />
                      <div v-else class="position-absolute w-100 h-100 d-flex align-items-center justify-content-center text-muted" style="top: 0;">
                        <i class="fi fi-rr-play-circle" style="font-size: 2rem;"></i>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6 mb-3">
                    <div class="d-flex justify-content-between mb-0">
                      <label class="font-weight-bold text-dark ">{{ $t('queue.portrait') }}</label>
                      <small class="text-muted" style="font-size: 11px;">3.6:1 (1080x300 px)</small>
                    </div>
                    <input type="text" class="form-control mb-2" v-model="videoBanner.portrait" placeholder="YouTube URL...">
                    <div class="video-preview-wrapper border rounded-lg shadow-sm bg-dark" style="padding-top: 50%;">
                      <LazyYoutube v-if="videoBanner.portrait"
                        :src="formatYoutubeUrl(videoBanner.portrait)" :autoplay="false" :loop="true" :mute="true"
                        class="position-absolute w-100 h-100" style="top: 0; left: 0;" />
                      <div v-else class="position-absolute w-100 h-100 d-flex align-items-center justify-content-center text-muted" style="top: 0;">
                        <i class="fi fi-rr-play-circle" style="font-size: 2rem;"></i>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="bg-light p-3 rounded-lg border">
                  <ul class="list-unstyled mb-0 small text-muted">
                    <li class="mb-1"><i class="fi fi-rr-check mr-2 text-success"></i> {{ $t('queue.videoHint') }}</li>
                    <li class="mb-1"><i class="fi fi-rr-volume-mute mr-2 text-warning"></i> {{ $t('queue.videoMute') }}</li>
                    <li class="text-danger font-weight-bold"><i class="fi fi-rr-info mr-2"></i> {{ $t('queue.videoPrivacy') }}</li>
                  </ul>
                </div>        
              </div>

                <!-- กรณีเลือกโหมดรูปภาพ (ซ่อนถ้า isVideoBanner เป็น true) -->
                <div v-else>
                  <div class="ad-section-group mb-4">
                    <div class="d-flex justify-content-between align-items-end mb-2">
                      <label class="font-weight-bold m-0">{{ $t('queue.adLandscape') }}</label>
                      <small class="text-muted">{{ $t('queue.adSizeHintLans') }}</small>
                    </div>
                    <div class="banner-grid">
                      <div v-for="i in 5" :key="'land-' + i" class="banner-item">
                        <CButton class="banner-box-small portrait" @click="selectBanner('landscape', i)">
                          <img v-if="banners.landscape[i]" :src="banners.landscape[i]" />
                          <span v-else>+</span>
                        </CButton>
                      </div>
                    </div>
                  </div>

                  <div class="ad-section-group">
                    <div class="d-flex justify-content-between align-items-end mb-2">
                      <label class="font-weight-bold m-0">{{ $t('queue.adPortrait') }}</label>
                      <small class="text-muted">{{ $t('queue.adSizeHintPort') }}</small>
                    </div>
                    <div class="banner-grid">
                      <div v-for="i in 5" :key="'port-' + i" class="banner-item">
                        <CButton class="banner-box-small landscape" @click="selectBanner('portrait', i)">
                          <img v-if="banners.portrait[i]" :src="banners.portrait[i]" />
                          <span v-else>+</span>
                        </CButton>
                      </div>
                    </div>
                  </div>
                  <div class="form-group mt-4 pt-3 border-top">
                    <label class="font-weight-bold">{{ $t('queue.slideSpeed') }}</label>
                    <select v-model="bannerSpeed" class="form-control">
                      <option v-for="s in [3, 5, 7, 10, 15]" :key="s" :value="s">
                        {{ s }} {{ $t('queue.sec') }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="config-card mb-3" v-if="displayQueue.mode === 'CUSTOMER'">
                <h5 class="section-title"><i class="fi fi-rr-users-alt mr-2"></i>{{ $t('queue.manageQueue') }}</h5>
                <p class="text-muted small">
                  {{ $t('queue.manageQueueDesc') }}
                </p>

                <div class="d-flex justify-content-between align-items-center mb-2">
                  <h6 class="fw-bold m-0">{{ $t('queue.manageZones') }} ({{ Object.keys(displayQueue.lanes || {}).length }}/6)</h6>
                  <button v-if="Object.keys(displayQueue.lanes || {}).length < 6" @click="openAddLaneModal" class="btn btn-success btn-sm">{{ $t('queue.addZone') }}</button>
                </div>

                <div class="row">
                  <div class="col-12 mb-2">
                    <div class="alert alert-success py-2 px-3 small m-0">
                      <i class="fi fi-rr-info mr-2"></i>
                      <strong>{{ $t('queue.hint') }}:</strong> {{ $t('queue.hintDesc') }}
                      <br>
                      <span class="text-muted ml-3">
                        {{ $t('queue.hintExample') }}
                      </span>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="row mb-2 px-3" v-if="Object.keys(displayQueue.lanes || {}).length > 1">
                      <div class="col font-weight-bold ">{{ $t('queue.name') }}</div>
                      <div class="col font-weight-bold ">{{ $t('queue.min') }}</div>
                      <div class="col font-weight-bold ">{{ $t('queue.max') }}</div>
                      <div class="col-auto" style="width: 45px;"></div> 
                    </div>

                    <div v-for="(lane, key) in displayQueue.lanes" :key="key" class="mb-2">
                      <div class="border rounded p-2 bg-light">
                        <div class="row align-items-center g-2">
                          <div class="col">
                            <input v-model="lane.prefix" class="form-control form-control-sm text-center fw-bold" maxlength="1" @blur="updateLaneKey(key, lane.prefix)">
                          </div>
                          <div class="col">
                            <input v-model.number="lane.min" class="form-control form-control-sm" type="number">
                          </div>
                          <div class="col">
                            <input v-model.number="lane.max" class="form-control form-control-sm" type="number">
                          </div>
                          <div class="col-auto">
                            <CButton @click="removeLane(key)" color="danger" size="sm" class="py-1 px-2">✕</CButton>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mt-4">
                  <div class="col-md-3">
                    <label class="font-weight-bold">{{ $t('queue.queueLength') }}</label>
                    <select v-model.number="displayQueue.postfixLength" class="form-control">
                      <option v-for="n in [1, 2, 3, 4]" :key="n" :value="n">{{ n }}</option>
                    </select>
                    <small class="text-muted mt-2 d-block">
                      {{ $t('queue.preview') }}: <strong>A{{ '0'.repeat(displayQueue.postfixLength - 1) + '1' }}</strong>
                    </small>
                  </div>
                  <div class="col-md-9">
                    <label class="font-weight-bold">{{ $t('queue.tickerInfo') }}</label>
                    <textarea v-model="displayQueue.information" class="form-control" rows="2" 
                              :placeholder="$t('queue.placeholderInfo')" style="resize: vertical;"></textarea>
                  </div>
                </div>
              </div>
            </CCol>

            <CCol xl="5" lg="6" md="12" >
              <div class="sticky-side-panel">
                <div class="config-card mb-3 p-0 overflow-hidden shadow-lg border-0 rounded-20">
                  <div class="preview-header p-3 bg-white border-bottom d-flex justify-content-between align-items-center">
                    <span class="font-weight-bold text-dark">
                      <i class="fi fi-rr-eye mr-2 text-primary"></i>{{ $t('queue.livePreview') }}
                    </span>
                    <CBadge :color="layoutType === 'landscape' ? 'info' : 'warning'" shape="pill" class="px-3 py-2">
                      <i :class="layoutType === 'landscape' ? 'fi fi-rr-screen' : 'fi fi-rr-smartphone'" class="mr-1"></i>
                      {{ layoutType === 'landscape' ? $t('queue.tvMode') : $t('queue.tabletMode') }}
                    </CBadge>
                  </div>

                  <div class="preview-body-container p-4 bg-dark d-flex justify-content-center align-items-center" style="min-height: 500px;">
                    <div class="monitor-mockup shadow-2xl" :class="layoutType">
                      <div class="mockup-top-nav" :style="{ backgroundColor: selectedTheme }">
                        <div class="shop-info">
                          <img v-if="layoutType === 'landscape' ? logoImage.landscape : logoImage.portrait" 
                              :src="layoutType === 'landscape' ? logoImage.landscape : logoImage.portrait" 
                              class="mockup-logo-img shadow-sm mr-2" />
                          <i v-else class="fi fi-rr-shop mr-2"></i>
                          <span class="mockup-shop-name font-weight-bold">{{ shopName }}</span> 
                        </div>
                        <div class="mockup-status-icons">
                          <span class="small mr-2 opacity-8">{{ currentTime }}</span>
                          <i class="fi fi-rr-wifi mr-2"></i>
                          <i class="fi fi-rr-settings"></i>
                        </div>
                      </div>
                      <div v-if="layoutType === 'portrait'" class="portrait-banner-top border-bottom">
                        <template v-if="isVideoBanner">
                          <div class="h-100 w-100 bg-black">
                            <LazyYoutube 
                              v-if="videoBanner.portrait"
                              :src="formatYoutubeUrl(videoBanner.portrait)" 
                              :autoplay="true" 
                              :loop="true" 
                              :mute="true"
                              class="h-100 w-100"
                            />
                            <div v-else class="h-100 w-100 d-flex align-items-center justify-content-center text-white-50">
                              <i class="fi fi-rr-play-circle" style="font-size: 2rem;"></i>
                            </div>
                          </div>
                        </template>

                        <template v-else-if="currentBanners.length > 0">
                          <carousel :per-page="1" :autoplay="true" :autoplay-timeout="bannerSpeed * 1000" :loop="true"
                                    :pagination-enabled="false" class="mockup-banner-carousel">
                            <slide v-for="(img, index) in currentBanners" :key="'p-slide-' + index">
                              <div class="banner-img-wrapper">
                                <img :src="img" class="obj-fit-cover" />
                              </div>
                            </slide>
                          </carousel>
                        </template>

                        <div v-else class="placeholder-banner-default-logo bg-white d-flex align-items-center justify-content-center h-100 w-100">
                          <img src="/logo_green.png" class="default-centered-logo opacity-5" />
                        </div>
                        
                      </div>
                      <div v-if="displayQueue.mode === 'CUSTOMER'" class="mockup-content-area" :class="{'flex-column': layoutType === 'portrait'}" :style="{ backgroundColor: hexToRgba(selectedTheme, 0.04) }" style="padding: 1.5%;">
                        <div  class="queue-display-container h-100"  style="gap: 1px;">
                           <div class="q-section-header-call  d-flex justify-content-between  " >
                            <span><i class="fi fi-rr-menu-burger mr-1"></i> {{ displayLanguage === 'TH' ? 'รายการคิว' : 'Current Queue' }}</span>
                            <CBadge  shape="pill" class="opacity-9 pb-1" :style="{ 
                              backgroundColor: hexToRgba(selectedTheme, 0.075), 
                              backdropFilter: 'blur(4px)' 
                            }" style="padding-top: 5px;">รออยู่ 9 {{ displayLanguage === 'TH' ? 'คิว' : 'Item' }}</CBadge>
                          </div>
                          <div  class="q-list-scroll p-0 pl-1 pr-1" :class="{'grid-mode': layoutType === 'landscape'}">
                            <div v-for="(lane, index) in previewLanes" :key="index"   >
                              <!-- ใช้สี Theme กับเส้นขอบด้านบน และพื้นหลังสีขาวตาม edited-image.jpg -->
                              <div class="q-section border-radius-10 bg-white shadow-sm p-1" :style="{ borderTop: `4px solid ${selectedTheme}` }">
                                <div class="d-flex justify-content-between mb-2">
                                  <!-- โซน Prefix -->
                                  <span class="font-weight-bold  small"> <CBadge :style="{ backgroundColor: hexToRgba(selectedTheme, 0.075), color: selectedTheme }" style="font-size: 10px;">{{ lane.prefix }}</CBadge> {{ lane.min }}-{{ lane.max }} คน</span>
                                  <!-- สี Theme เข้ม 7.5% (ตัวอย่างใช้การปรับความสว่าง) -->
                                  <CBadge :style="{ backgroundColor: hexToRgba(selectedTheme, 0.075), color: selectedTheme }">5 คิว</CBadge>
                                </div>
                                
                                <!-- เลขคิว ใช้สี Theme -->
                                <div class="h5 font-weight-bold mb-0 text-center" :style="{ color: selectedTheme }">{{ lane.prefix }}{{ '0'.repeat((displayQueue.postfixLength || 1) - 1) }}0</div>
                                
                                <!-- ชื่อพนักงานและไอคอน -->
                                <div class=" text-center small"   :style="{ color: hexToRgba(selectedTheme, 0.5) }">
                                  <i class="fi fi-rr-user mr-1"></i> 
                                  <span >สมชาย</span>
                                </div>
                                
                                <hr class="my-0"> 
                                
                                <!-- รายการถัดไป -->
                                <small class="text-muted">ถัดไป: {{ lane.prefix }}{{ '0'.repeat((displayQueue.postfixLength || 1) - 1) }}1,  {{ lane.prefix }}{{ '0'.repeat((displayQueue.postfixLength || 1) - 1) }}2</small>
                              </div>
                            </div>
                          </div>
                          
                          <!-- แถบข้อมูลด้านล่าง: พื้นหลังสีขาว พร้อมไอคอนสี Theme -->
                          <div v-if="displayQueue.information" class="fixed-bottom-info bg-white p-1 m-1 " style="border-radius: 5px;">
                            <i class="fi fi-rr-megaphone mr-2" :style="{ color: selectedTheme }"></i> 
                            <span class="text-dark">{{ displayQueue.information }}</span>
                          </div>
                        </div>
                        <div v-if="layoutType === 'landscape'" class="ads-display-container ml-2">
                
                          <template v-if="isVideoBanner">
                              <div class="h-100 w-100 bg-black rounded-12 overflow-hidden shadow-sm">
                                <LazyYoutube 
                                  v-if="videoBanner.landscape"
                                  :src="formatYoutubeUrl(videoBanner.landscape)" 
                                  :autoplay="true" 
                                  :loop="true" 
                                  :mute="true"
                                  class="h-100 w-100"
                                />
                                <div v-else class="h-100 w-100 d-flex align-items-center justify-content-center text-white-50">
                                  <i class="fi fi-rr-play-circle" style="font-size: 3rem;"></i>
                                </div>
                              </div>
                            </template>
                            <template v-if="currentBanners.length > 0">
                              <carousel :per-page="1" :autoplay="true" :autoplay-timeout="bannerSpeed * 1000" :loop="true" :pagination-enabled="false" class="h-100">
                                <slide v-for="(img, index) in currentBanners" :key="'slide-'+index">
                                  <div class="ad-mock-image rounded-12 overflow-hidden shadow-sm h-100">
                                    <img :src="img" class="obj-fit-cover" />
                                  </div>
                                </slide>
                              </carousel>
                              <div class="ad-pagination-dots" style="position: absolute; bottom: 10px; width: 100%; display: flex; justify-content: center; gap: 5px; z-index: 5;">
                                <span v-for="(dot, dIdx) in currentBanners" 
                                    :key="'dot-'+dIdx" 
                                    class="dot" 
                                    :class="{ active: dIdx === 0 }"
                                    :style="dIdx === 0 ? { backgroundColor: selectedTheme, width: '12px', height: '12px' } : { backgroundColor: '#ccc', width: '8px', height: '8px', opacity: '0.5' }"
                                    style="border-radius: 50%; transition: all 0.3s ease; display: inline-block;">
                                </span>
                              </div>
                            </template>
                            <div v-else class="ad-placeholder-default-logo rounded-12 bg-white h-100 w-100 d-flex align-items-center justify-content-center shadow-sm">
                              <!-- <img v-if="logoImage.landscape" :src="logoImage.landscape" class="default-centered-logo" /> -->
                              <img src="/logo_green.png" class="default-centered-logo opacity-5" />
                            </div>
                          </div>
                      </div>
                      <div v-else class="mockup-content-area" :class="{'flex-column': layoutType === 'portrait'}" :style="{ backgroundColor: hexToRgba(selectedTheme, 0.1) }">
                          <div class="queue-display-container h-100" >
                            <div class="q-section border-radius-10 overflow-hidden">
                              <div class="q-section-header bg-blue-status d-flex justify-content-between px-3 py-2 " :style="{ backgroundColor: selectedTheme }">
                                <span>{{ displayLanguage === 'TH' ? 'รายการคิว' : 'Current Queue' }}</span>
                                <CBadge  shape="pill" class="opacity-9 pb-0" :style="{ 
                                  backgroundColor: 'rgba(255, 255, 255, 0.2)', 
                                  color: '#fff',
                                  backdropFilter: 'blur(4px)' 
                                }" style="padding-top: 5px;">9 {{ displayLanguage === 'TH' ? 'รายการ' : 'Item' }}</CBadge>
                              </div>
                              <div class="q-list-scroll p-2" :class="{'grid-mode': layoutType === 'landscape'}">
                                <div v-for="i in (layoutType === 'landscape' ? 6 : 4)" :key="'cur-'+i" class="q-ticket-mini animate-in"  :style="{ borderLeft: `3px solid ${selectedTheme}` }">
                                  <div class="q-ticket-icon"  :style="{ backgroundColor: selectedTheme }" style="color: white;"><i class="fi fi-rr-store-alt " ></i></div>
                                  <div class="q-ticket-id font-weight-bold" >Q{{i+8}}</div>
                                  <div class="q-ticket-meta">1 {{ displayLanguage === 'TH' ? 'รายการ' : 'Item' }} <i class="fi fi-rr-restaurant ml-1 text-muted"></i></div>
                                </div>
                              </div>
                            </div>

                            <div class="q-section mt-0 border-radius-10 overflow-hidden">
                              <div class="q-section-header bg-orange-status d-flex justify-content-between px-3 py-2 text-white">
                                <span>{{ displayLanguage === 'TH' ? 'กำลังเตรียม' : 'Preparing' }}</span>
                                <CBadge  shape="pill" :style="{ 
                                  backgroundColor: 'rgba(255, 255, 255, 0.2)', 
                                  color: '#fff',
                                  backdropFilter: 'blur(4px)' 
                                }" style="padding-top: 5px;">1 {{ displayLanguage === 'TH' ? 'รายการ' : 'Items' }}</CBadge>
                              </div>
                              <div class="q-list-scroll p-2">
                                <div class="q-ticket-mini border-orange shadow-none" :style="{ borderLeft: `3px solid ${selectedTheme}` }">
                                  <div class="q-ticket-icon"  :style="{ backgroundColor: selectedTheme}" style="color: white;"><i class="fi fi-rr-store-alt "></i></div>
                                  <div class="q-ticket-id font-weight-bold ">Q4</div>
                                  <div class="q-ticket-meta text-orange">3 รายการ</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-if="layoutType === 'landscape'" class="ads-display-container ml-2">
                                     
                             <template v-if="isVideoBanner">
                              <div class="h-100 w-100 bg-black rounded-12 overflow-hidden shadow-sm">
                                <LazyYoutube 
                                  v-if="videoBanner.landscape"
                                  :src="formatYoutubeUrl(videoBanner.landscape)" 
                                  :autoplay="true" 
                                  :loop="true" 
                                  :mute="true"
                                  class="h-100 w-100"
                                />
                                <div v-else class="h-100 w-100 d-flex align-items-center justify-content-center text-white-50">
                                  <i class="fi fi-rr-play-circle" style="font-size: 3rem;"></i>
                                </div>
                              </div>
                            </template>
                            <template v-if="currentBanners.length > 0 && !isVideoBanner" >
                              <carousel :per-page="1" :autoplay="true" :autoplay-timeout="bannerSpeed * 1000" :loop="true" :pagination-enabled="false" class="h-100">
                                <slide v-for="(img, index) in currentBanners" :key="'slide-'+index">
                                  <div class="ad-mock-image rounded-12 overflow-hidden shadow-sm h-100">
                                    <img :src="img" class="obj-fit-cover" />
                                  </div>
                                </slide>
                              </carousel>
                              <div class="ad-pagination-dots" style="position: absolute; bottom: 10px; width: 100%; display: flex; justify-content: center; gap: 5px; z-index: 5;">
                                <span v-for="(dot, dIdx) in currentBanners" 
                                    :key="'dot-'+dIdx" 
                                    class="dot" 
                                    :class="{ active: dIdx === 0 }"
                                    :style="dIdx === 0 ? { backgroundColor: selectedTheme, width: '12px', height: '12px' } : { backgroundColor: '#ccc', width: '8px', height: '8px', opacity: '0.5' }"
                                    style="border-radius: 50%; transition: all 0.3s ease; display: inline-block;">
                                </span>
                              </div>
                            </template>
                            <div v-else class="ad-placeholder-default-logo rounded-12 bg-white h-100 w-100 d-flex align-items-center justify-content-center shadow-sm">
                              <!-- <img v-if="logoImage.landscape" :src="logoImage.landscape" class="default-centered-logo" /> -->
                              <img src="/logo_green.png" class="default-centered-logo opacity-5" />
                            </div>
                          </div>
                      </div>

                      <div class="mockup-footer-brand d-flex justify-content-end align-items-center px-3 py-2 border-top bg-white">
                        <span class="text-muted mr-1" style="font-size: 10px;">Powered by</span>
                        <img src="/SilomPOS_logo.png" style="height: 12px; opacity: 0.7;" />
                      </div>
                    </div>
                  </div>
                </div>


              </div>
              <div class="status-card p-4 shadow-sm border-0">
                  <div class="d-flex align-items-center mb-3">
                    <div class="status-indicator mr-2" :class="{ 'bg-warning': isDirty, 'bg-success': !isDirty }"></div>
                    <span class="small font-weight-bold">
                      {{ isDirty ? $t('queue.statusDirty') : $t('queue.statusSaved') }}
                    </span>
                  </div>
                  
                  <CButton 
                    block 
                    color="success" 
                    class="save-btn-large py-3 shadow-sm" 
                    :disabled="!isDirty || !loadindSave || !isQueueDisplayEdit"
                    @click="prepareSave()">
                    <i class="fi fi-rr-disk mr-2"></i> {{ $t('queue.saveBtn') }}
                  </CButton>
                  
                  <p class="text-muted small mt-3 mb-0">
                    <i class="fi fi-rr-info mr-1"></i> {{ $t('queue.saveHint') }}
                  </p>
                </div>
            </CCol>
          </CRow>

          <CModal color="success" :show.sync="confirmModal" centered>
            <div class="p-4 text-center">
              <h4 class="mb-3">{{ $t('queue.confirmTitle') }}</h4>
              <p>{{ $t('queue.confirmDetail') }}</p>

              <div v-if="deletedLanesQueue.length > 0" class="alert alert-warning text-left small mt-3">
                <strong>{{ $t('queue.deleteWarningTitle') }}</strong>
                  <ul class="mb-0">
                    <li v-for="lane in deletedLanesQueue" :key="lane">
                      {{ $t('queue.laneLabel') }} {{ lane }}
                    </li>
                  </ul>
                  <hr class="my-2">
                  <p class="text-dark mb-0">
                    <strong>{{ $t('queue.deleteSuggestion') }}</strong>
                  </p>
              </div>
            </div>
            <template #footer>
              <CButton color="light" class="px-4" @click="confirmModal = false">{{ $t('cancel') }}</CButton>
              <CButton   color="success" v-if="loadindSave === true" class="px-4"
                  v-on:click="saveConfig()">
                  {{ $t('save') }}
              </CButton>
              <CButton id="kioskSettingSaveButtonDisabled"  color="success" class="px-4"
                  v-else-if="loadindSave === false" disabled>
                  <CSpinner color="white" size="sm" /> {{ $t('save') }}
              </CButton>
            </template>
          </CModal>

          <CModal :show.sync="additionalModal" centered :title="$t('queue.uploadTitle')">
            <div class="p-3 text-center row justify-content-center">
              <div v-if="!currentImg" class="upload-dropzone" @click="$refs.fileInput.click()">
                <input type="file" ref="fileInput" class="d-none" accept="image/*" @change="handleFileChange($event.target)" />
                <i class="fi fi-rr-upload-alt mb-2 h2"></i>
                <div>{{ $t('queue.clickUpload') }}</div>
              </div>

              <div v-else class="preview-container w-100 px-4">
                <div class="position-relative d-inline-block mb-3">
                  <img :src="currentImg" class="img-fluid rounded shadow-sm border" style="max-height: 250px;" />
                </div>
                
                <div class="d-flex justify-content-center gap-2 mb-2">
                  <CButton color="info" variant="outline" size="sm" class="mr-2" @click="$refs.fileInput.click()">
                    <i class="fi fi-rr-refresh mr-1"></i> {{ $t('queue.changeImg') || 'เปลี่ยนรูป' }}
                  </CButton>
                  
                  <CButton color="danger" variant="outline" size="sm" @click="handleRemoveCurrentImg">
                    <i class="fi fi-rr-trash mr-1"></i> {{ $t('queue.removeImg') }}
                  </CButton>
                </div>
                
                <input type="file" ref="fileInput" class="d-none" accept="image/*" @change="handleFileChange($event.target)" />
              </div>
            </div>

            <template #footer-wrapper>
              <CRow class="p-4">
                <CCol>
                  <CButton
                    block
                    color="success"
                    :disabled="!isModalDirty || !loadingSaveimg"
                    @click="onBanner ? saveBannerLocal() : saveLogoLocal()"
                  >
                    <span v-if="!loadingSaveimg"><CSpinner size="sm"/></span>
                    {{ $t("save") }}
                  </CButton>
                </CCol>
                <CCol>
                  <CButton block color="light" @click="additionalModal = false">
                    {{ $t("cancel") }}
                  </CButton>
                </CCol>
              </CRow>
            </template>
          </CModal>
        </div>
        <div v-else  class="text-center">
          <img src="/img/bn_Q.png" class="img-fluid" width="80%"  />
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";
import uploadImage from "@/util/uploadImage";
import mime from "@/util/mime";
import pos from '@/services/local';
import VueCropper from 'vue-cropperjs'
import firebase from 'firebase'
import { mapGetters } from 'vuex'
import util from '@/util/util'
import permis from '@/util/permission'
import { LazyYoutube } from "vue-lazytube"

export default {
 components: {
  Carousel,
  Slide,
  LazyYoutube
 },

 data() {
  return {
    isVideoBanner: false,
    videoBanner: {
      landscape: "",
      portrait: ""
    },
    
    confirmModal: false,
    // Logo
    logoImage: {
      landscape: "",
      portrait: ""
    },

    // Theme
    themeColor: this.selectedTheme,

    // Layout
    layoutType: "landscape",
    currentType : null,

    // Language
    displayLanguage: "TH",

    // Voice
    enableVoice: false,
    voiceLanguages: [],

    // Banner
    banners: {
      landscape: {
        "1": null,
        "2": null,
        "3": null,
        "4": null,
        "5": null
      },
      portrait: {
        "1": null,
        "2": null,
        "3": null,
        "4": null,
        "5": null
      }
    },
    bannerSpeed: 10,
    // temp
    currentIndex: null,
    currentImg: "",
    isUploading: false,
    themeColorOptions: [
      { code: "#29B46B", name: "SilomPOS Green" },
      { code: "#558B2F", name: "Forest Green" },
      { code: "#00897B", name: "Teal" },
      { code: "#ADD02C", name: "Lime Green" },
      { code: "#B71C1C", name: "Crimson Red" },
      { code: "#EF6C00", name: "Burnt Orange" },
      { code: "#FFB300", name: "Amber" },
      { code: "#880E4F", name: "Maroon" },
      { code: "#C2185B", name: "Rose" },
      { code: "#A64594", name: "Orchid" },
      { code: "#144265", name: "Navy Blue" },
      { code: "#0277BD", name: "Medium Blue" },
      { code: "#75B7ED", name: "Sky Blue" },
      { code: "#78909C", name: "Slate Gray" },
      { code: "#A1887F", name: "Taupe" },
      { code: "#6D4C41", name: "Mocha" },
      { code: "#999999", name: "Grey" },
      { code: "#212121", name: "Charcoal" },
    ],
    mockQueue: {
      current: [{ no: "Q17", table: "Table 5" }],
      preparing: [
      { no: "Q1", table: "B-2" },
      { no: "Q2", table: "Table 7" },
      { no: "Q3", table: "B-1" },
      ],
    },
    currentTime: "",
    selectedTheme: "#29B46B",
    isDirty: false,
    additionalModal : false,
    onBanner: false,
    loadingSaveimg: true,
    loading : true,
    loadindSave: true,
    displayQueue: {
      enabledServeQueue: false,
      logo: {
        landscape: "",
        portrait: ""
      },
      banners: {
        landscape: {
          "1": null,
          "2": null,
          "3": null,
          "4": null,
          "5": null
        },
        portrait: {
          "1": null,
          "2": null,
          "3": null
        }
      },
      screenOrientation: 0,
      bannersDuration: 10,
      themeColor: "#29B46B",
      textLanguage: "TH",
      ttsLanguage: [],
      mode: "ORDER", // "ORDER" หรือ "CUSTOMER"
      postfixLength: 2, // 1, 2, 3, 4
      lanes: {}, // เก็บ { "A": { prefix: "A", min: 1, max: 2 }, ... }
      information: "" // ข้อความวิ่ง
    },
   deletedLanesQueue: [],
   shopName: "",
   datashop: {},
   isModalDirty: false,
   originalLanes: {},
  };
 },
 mounted() {
  this.updateTime();
  setInterval(this.updateTime, 1000);
 },
 created(){
  this.getOrderShopSetting()
 },
 watch: {
    // ตรวจจับการเปลี่ยนแปลงของ Object หรือตัวแปรที่ต้องการ
    // หากมีการแก้ไขค่าใดๆ ให้เปิดปุ่มบันทึก
    selectedTheme() { this.isDirty = true },
    layoutType() { this.isDirty = true },
    displayLanguage() { this.isDirty = true },
    enableVoice() { this.isDirty = true },
    voiceLanguages: {
      handler() { this.isDirty = true },
      deep: true
    },
    bannerSpeed() { this.isDirty = true }
  },
  computed:{
     ...mapGetters(['shops', 'users', 'date', 'access', 'permissions']),
    isQueueDisplayEnabled: {
        get() {
            const queueDisplayMenu = this.permissions.setting.menu.find(menu => menu.label === 'silomqueueDisplay');
            const queueLock = queueDisplayMenu.lock
            if ( queueLock === false) {
                return true;
            } else {
                return false;
            }
        },
    },
    isQueueDisplayEdit: {
        get() {
            const queueDisplayMenu = this.permissions.setting.menu.find(menu => menu.label === 'silomqueueDisplay');
            const queueLock = queueDisplayMenu.edit
            return queueLock
        },
    },

     previewLanes() {
      if (!this.displayQueue.lanes) return [];
      // แปลง Object เป็น Array เพื่อให้ slice ได้
      const lanesArray = Object.keys(this.displayQueue.lanes).map(key => ({
        key: key,
        ...this.displayQueue.lanes[key]
      }));
      return lanesArray.slice(0, 3);
    },
    isCustomerMode() {
      return this.displayQueue.mode === "CUSTOMER";
    },
    currentOrientation() {
      return this.displayQueue.screenOrientation === 0
        ? "landscape"
        : "portrait"
    },
    shop() {
      // คืนค่าเป็น object เสมอเพื่อป้องกัน Error
      return this.shops.find((i) => i.objectId === this.shopObjectId) || {};
    },
    currentBanners() {
      if (this.layoutType === 'landscape') {
        return Object.values(this.banners.landscape || {}).filter(Boolean)
      }else{
          return Object.values(this.banners.portrait || {}).filter(Boolean)
      }
    },
    currentLogo() {
      return this.displayQueue.logo[this.currentOrientation]
    },
    uid() {
      return `${localStorage.getItem('shopsUid')}`
    },
    shopObjectId: {
        get() {
            return this.$store.getters.shopObjectId
        },
    },
  },
 methods: {
  formatYoutubeUrl(url) {
    if (!url) return '';
    
    // ตรวจสอบว่าเป็นลิงก์ YouTube Shorts หรือไม่
    if (url.includes('/shorts/')) {
      // แทนที่ /shorts/ ด้วย /watch?v= เพื่อให้อยู่ใน Format สากลที่ปลั๊กอินรองรับ
      return url.replace('/shorts/', '/watch?v=');
    }
    
    return url;
  },
  setVideoMode(mode) {
    if (this.isVideoBanner !== mode) {
      this.isVideoBanner = mode;
      this.isDirty = true; // เมื่อมีการเปลี่ยนโหมด ให้เปิดใช้งานปุ่มบันทึก
    }
  },
  getYoutubeID(url) {
    if (!url) return '';
    
    // ปรับ Regex ให้ครอบคลุมรูปแบบ /shorts/ เพิ่มเติม
    const regExp = /^.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|shorts\/)([^#\&\?]{11})/;
    const match = url.match(regExp);
    
    return match ? match[1] : null;
  },
  validate() {
      // if (this.isVideoBanner) {
      //   if (!this.videoBanner.landscape || !this.getYoutubeID(this.videoBanner.landscape)) {
      //     alert("กรุณากรอกลิงก์ YouTube ให้ถูกต้อง");
      //     return false;
      //   }
      // }
      // ... กฎการตรวจสอบอื่นๆ ของคุณ
      return true;
    },
  getDeletedLanes() {
    // 1. originalLanes เป็น Object อยู่แล้ว ไม่ต้อง parse
    const original = this.originalLanes || {}; 
    
    // 2. ดึง keys ปัจจุบัน
    const currentKeys = Object.keys(this.displayQueue.lanes || {});
    
    // 3. หา keys ที่อยู่ใน original แต่ไม่อยู่ใน current
    return Object.keys(original).filter(key => !currentKeys.includes(key));
  },
  
  // เรียกใช้ฟังก์ชันนี้ก่อนโชว์ Modal
  prepareSave() {
    // คำนวณเลนที่หายไปก่อนจะเปิด Modal
    this.deletedLanesQueue = this.getDeletedLanes();
    this.confirmModal = true;
  },
  hasQueueInLane(lane) {
      return lane.queueList && lane.queueList.length > 0;
    },
  openAddLaneModal() {
    const currentKeys = Object.keys(this.displayQueue.lanes || {});
    
    if (currentKeys.length >= 6) {
      alert("จำกัดสูงสุดเพียง 6 โซนเท่านั้น");
      return;
    }

    // หาตัวอักษร A-F ที่ยังไม่มีใน Object
    let newKey = "";
    for (let i = 0; i < 6; i++) {
      const char = String.fromCharCode(65 + i); // A, B, C, D, E, F
      if (!currentKeys.includes(char)) {
        newKey = char;
        break;
      }
    }

    if (newKey) {
      this.$set(this.displayQueue.lanes, newKey, { 
        prefix: newKey, 
        min: 1, 
        max: 1 
      });
      this.isDirty = true;
    }
  },
  handleRemoveCurrentImg() {
    this.currentImg = "";
    this.isModalDirty = true; // 🔥 มาร์คว่ามีการแก้ไข (เป็นการสั่งลบรูป)
  },
  hexToRgba(hex, opacity) {
    let c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split('');
      if (c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = '0x' + c.join('');
      return `rgba(${(c >> 16) & 255}, ${(c >> 8) & 255}, ${c & 255}, ${opacity})`;
    }
    return hex;
  },
  // =========================
  // FILE → BASE64
  // =========================
  fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => resolve(reader.result)
      reader.onerror = reject
      reader.readAsDataURL(file)
    })
  },
  // =========================
  // RESIZE IMAGE (รักษาสัดส่วน & จำกัด 2MB)
  // =========================
  resizeImage(base64Str, maxFileSizeMB = 2) {
    return new Promise((resolve) => {
      // 1. ตรวจสอบ Mime Type ต้นฉบับจาก Base64 string
      const mimeType = base64Str.substring(base64Str.indexOf(":") + 1, base64Str.indexOf(";"));
      
      // กำหนดให้ใช้ PNG ถ้าต้นฉบับเป็น PNG หรือ SVG (เพื่อรักษาความโปร่งใส)
      // นอกเหนือจากนั้นให้เปลี่ยนเป็น JPEG เพื่อประหยัดขนาดไฟล์
      const outputMimeType = (mimeType === 'image/png' || mimeType === 'image/svg+xml') 
        ? 'image/png' 
        : 'image/jpeg';

      const img = new Image();
      img.crossOrigin = 'Anonymous'; 
      img.src = base64Str;

      img.onload = () => {
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');

        let width = img.width;
        let height = img.height;

        const MAX_SAFE_WIDTH = 1920;
        if (width > MAX_SAFE_WIDTH) {
          const scaleFactor = MAX_SAFE_WIDTH / width;
          width = MAX_SAFE_WIDTH;
          height = height * scaleFactor;
        }

        canvas.width = width;
        canvas.height = height;

        // 🔥 สำคัญ: เคลียร์ Canvas ให้โปร่งใสก่อนวาดภาพ
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        ctx.drawImage(img, 0, 0, width, height);

        // 2. วนลูปลดขนาดไฟล์โดยอิงตาม Mime Type ที่เหมาะสม
        let quality = 0.9;
        let dataUrl = canvas.toDataURL(outputMimeType, quality);
        const maxSizeBytes = maxFileSizeMB * 1024 * 1024;

        // หมายเหตุ: การปรับ quality ใน toDataURL จะแสดงผลได้ดีกับ image/jpeg
        // สำหรับ image/png เบราว์เซอร์ส่วนใหญ่จะเพิกเฉยต่อพารามิเตอร์นี้
        // แต่เรายังคง Loop ไว้เพื่อความปลอดภัยในแง่ขนาดไฟล์
        while ((dataUrl.length * 0.75) > maxSizeBytes && quality > 0.1) {
          quality -= 0.1;
          dataUrl = canvas.toDataURL(outputMimeType, quality);
        }

        resolve(dataUrl);
      };
    });
  },
  // =========================
  // UPLOAD IMAGE (Firebase)
  // =========================
  async uploadImageToFirebase(base64, path) {
    try {
      const url = await uploadImage.onUpload2(path, base64)

      if (!url || !url.startsWith('https://firebasestorage')) {
        throw new Error('Upload failed')
      }

      return url
    } catch (err) {
      console.error('Upload error:', err)
      this.loginAgainModal = true
      throw err
    }
  },
  // =========================
  // HANDLE IMAGE UPLOAD (ใช้จริง)
  // =========================
  async handleUploadImage(file) {
    try {
      const uid = this.uid

      // 1. file → base64
      const base64 = await this.fileToBase64(file)

      // 2. resize
      const resized = await this.resizeImage(base64)

      // 3. upload
      const path = `resources/${uid}/resources/customUpload`
      const url = await this.uploadImageToFirebase(resized, path)

      console.log('Uploaded URL:', url)

      return url
    } catch (error) {
      console.error(error)
    }
  },
  // =========================
  // HANDLE VIDEO UPLOAD
  // =========================
  async handleUploadVideo(blobUrl) {
    try {
      const uid = this.uid

      const response = await fetch(blobUrl)
      const blob = await response.blob()

      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })

      const path = `resources/${uid}/resources/video`
      const url = await this.uploadImageToFirebase(base64, path)

      return url
    } catch (err) {
      console.error(err)
    }
  },
  updateTime() {
   const now = new Date();
   this.currentTime = now.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
   });
  },
  saveButtonClass(isDirty) {
   if (isDirty == false) {
    return "floating-save-btn btn btn-success";
   } else {
    return "floating-save-btn-dirty btn btn-success";
   }
  },
  toggleVoice() {
   this.enableVoice = !this.enableVoice;
   this.isDirty = true;

   if (!this.enableVoice) {
    this.voiceLanguages = [];
   }
  },
  toggleVideo(){
    this.isVideoBanner = !this.isVideoBanner
    this.isDirty = true;
  },
  toggleVoiceLang(lang) {
   const index = this.voiceLanguages.indexOf(lang);

   if (index === -1) {
    this.voiceLanguages.push(lang); // add (ท้าย = ลำดับ)
   } else {
    this.voiceLanguages.splice(index, 1); // remove
   }

   this.isDirty = true;
  },
  setDisplayLanguage(lang) {
   if (this.displayLanguage !== lang) {
    this.displayLanguage = lang;
    this.isDirty = true;
   }
  },
  setLayout(type) {
   if (this.layoutType !== type) {
    this.layoutType = type;
    this.isDirty = true;

    this.$nextTick(() => {
     const el = document.getElementById("preview-section");
     el?.scrollIntoView({ behavior: "smooth" });
    });
   }
  },
  // ======================
  // IMAGE
  // ======================
  setThemeColor(color) {
   this.selectedTheme = color.code;
  },
  updateTheme(event) {
   this.selectedTheme = event.target.value;
  },
  getTextColor(bg) {
   const color = bg.replace("#", "");
   const r = parseInt(color.substring(0, 2), 16);
   const g = parseInt(color.substring(2, 4), 16);
   const b = parseInt(color.substring(4, 6), 16);

   const brightness = (r * 299 + g * 587 + b * 114) / 1000;
   return brightness > 150 ? "#000" : "#fff";
  },
  // ======================
  // UTILS
  // ======================
  handleFileChange(input) {
    const file = input.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      this.currentImg = e.target.result;
      this.isModalDirty = true; // เปิดให้กด Save ได้
    };
    reader.readAsDataURL(file);
    input.value = ''; // เคลียร์เพื่อให้เลือกไฟล์เดิมซ้ำได้
  },
  // ======================
  // LOGO
  // ======================
  openLogoModal(type) {
    this.onBanner = false
    this.currentType = type
    this.currentIndex = 'logo'
    this.currentImg = this.logoImage[type] || ""
    this.isModalDirty = false; 
    this.additionalModal = true
  },
  // ======================
  // LOGO ACTIONS
  // ======================
  async saveLogoLocal() {
    if (!this.isModalDirty) return; // บันทึกได้กรณีมีการแก้ไขเท่านั้น
    this.loadingSaveimg = false;
    try {
      let finalImg = "";
      if (this.currentImg) {
        // จำกัด 2MB และรักษาสัดส่วน
        finalImg = await this.resizeImage(this.currentImg, 2);
      }
      
      this.$set(this.logoImage, this.currentType, finalImg);
      this.isDirty = true;
      this.additionalModal = false;
    } catch (err) {
      console.error('Save Logo Error:', err);
    } finally {
      this.loadingSaveimg = true;
    }
  },
  // ======================
  // BANNER
  // ======================
  selectBanner(type, key) {
    if (this.isVideoBanner) {
      alert("กรุณาปิดโหมดวิดีโอก่อนแก้ไขรูปภาพ");
      return;
    }
    this.onBanner = true
    this.currentType = type        // 👈 เพิ่ม
    this.currentIndex = key
    this.currentImg = this.banners[type][key] || ""
    this.isModalDirty = false;
    this.additionalModal = true
  },
  async saveBanner() {
   const resized = await this.resizeImage(this.currentImg);
   this.$set(this.banners[this.currentType], this.currentIndex, resized);
   this.currentImg = "";
  },
  // ======================
  // UPLOAD FIREBASE
  // ======================
  async uploadAllImages() {
    this.isUploading = true;

    // ======================
    // LOGO
    // ======================
    if (this.logoImage.landscape && !this.logoImage.landscape.startsWith("http")) {
      this.logoImage.landscape = await this.uploadToFirebase(
        this.logoImage.landscape,
        "landscape",
        true
      )
    }

    if (this.logoImage.portrait && !this.logoImage.portrait.startsWith("http")) {
      this.logoImage.portrait = await this.uploadToFirebase(
        this.logoImage.portrait,
        "portrait",
        true
      )
    }

    // ======================
    // BANNER LANDSCAPE
    // ======================
    for (const key in this.banners.landscape) {
      const img = this.banners.landscape[key]

      if (img && !img.startsWith("http")) {
        this.banners.landscape[key] = await this.uploadToFirebase(
          img,
          "landscape",
          false,
          key
        )
      }
    }

    // ======================
    // BANNER PORTRAIT
    // ======================
    for (const key in this.banners.portrait) {
    const img = this.banners.portrait[key]

    if (img && !img.startsWith("http")) {
      this.banners.portrait[key] = await this.uploadToFirebase(
        img,
        "portrait",
        false,
        key
      )
    }
  }

    this.isUploading = false;
  },
  async uploadToFirebase(base64, orientation, isLogo = false, key = null) {
    const ext = mime.getExtension(base64) || 'png'

    let fileName = ''

    if (isLogo) {
      fileName = `logo.${ext}`
    } else {
      fileName = `${key}.${ext}`   // 👈 ใช้ key ตรง ๆ
    }

    const path = `queueDisplay/${this.uid}/${this.shopObjectId}/${orientation}/${fileName}`

    return await uploadImage.onUpload2(path, base64)
  },
  // ======================
  // VALIDATE
  // ======================
  validate() {
    // ======================
    // BANNER (ต้องมีอย่างน้อย 1 รูปตาม layout ที่เลือก)
    // ======================
    // const bannerObj = this.banners[this.layoutType]

    // const currentBannerList = Array.isArray(bannerObj)
    //   ? bannerObj
    //   : Object.values(bannerObj || {})

    // const hasBanner = currentBannerList.some(img => !!img)

    // if (!hasBanner) {
    //   alert(
    //     `กรุณาเพิ่ม Banner สำหรับโหมด${
    //       this.layoutType === "landscape" ? "แนวนอน" : "แนวตั้ง"
    //     }`
    //   )
    //   return false
    // }

    // ======================
    // VOICE
    // ======================
    if (this.enableVoice && this.voiceLanguages.length === 0) {
      alert("กรุณาเลือกภาษาเสียง")
      return false
    }

    // ======================
    // SPEED
    // ======================
    if (!this.bannerSpeed || this.bannerSpeed < 1) {
      alert("ความเร็วสไลด์ไม่ถูกต้อง")
      return false
    }

    // ======================
    // THEME COLOR
    // ======================
    if (!this.selectedTheme || !this.selectedTheme.startsWith("#")) {
      alert("สีธีมไม่ถูกต้อง")
      return false
    }

    if (!this.displayQueue.postfixLength || this.displayQueue.postfixLength < 1) {
      alert("กรุณาเลือกความยาวเลขคิว");
      return false;
    }

    return true
  },
  // ======================
  // SAVE
  // ======================
  async saveConfig() {
    
    if (!this.validate()) return;

    this.loading = false
    this.loadindSave = false

    try {
      const lanesToRemove = this.getDeletedLanes();

      // 2. ถ้ามีเลนหายไป ให้เรียก API ลบก่อน
      if (lanesToRemove.length > 0) {
        for (const laneKey of lanesToRemove) {
          await pos({
            method: 'post',
            url: '/api/V3.0/queue/customer/clear',
            headers: { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId) },
            data: { shopObjectId: this.shopObjectId, lane: laneKey }
          });
        }
      }
      // 🔥 upload รูปทั้งหมดก่อน (ถ้ามี base64)
      await this.uploadAllImages()
      let uid = this.uid
      let objectIdToUse = this.shopObjectId

      const payload = {
        displayQueue: {
          // ✅ logo แยก orientation
          logo: {
            landscape: this.logoImage.landscape || "",
            portrait: this.logoImage.portrait || ""
          },

          // ✅ banner เป็น object (1-5)
          banners: this.banners,

          // ✅ layout
          screenOrientation: this.layoutType === "landscape" ? 0 : 1,

          // ✅ speed
          bannersDuration: this.bannerSpeed,

          // ✅ theme
          themeColor: this.selectedTheme,

          // ✅ language
          textLanguage: this.displayLanguage,

          // ✅ voice
          ttsLanguage: this.enableVoice ? this.voiceLanguages : [],

          mode: this.displayQueue.mode || "ORDER",
          postfixLength: this.displayQueue.postfixLength || 2,
          lanes: this.displayQueue.lanes || {},
          information: this.displayQueue.information || "",
          isVideoBanner: this.isVideoBanner,
          videoBanner: this.videoBanner
        },
        shopId : this.datashop.id,
        uid: this.uid,
        updated_at : new Date()

      }
       await pos({
                method: 'patch',
                url: `/api/v2.0/${uid}/OrderShopSetting/${objectIdToUse}`,
                headers: { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId) },
                data: payload,
            }).then((res) => {
                this.loading = true;
                this.isDirty = false;
                this.confirmModal = false;
                this.loadindSave = true;

                this.getOrderShopSetting();
            });

      // TODO: call API จริง
      // await api.patch('/display-queue', payload)

      this.isDirty = false
      this.confirmModal = false

    } catch (err) {
      console.error(err)
    } finally {
      this.loading = true
    }
  },
  updateLaneKey(oldKey, newPrefix) {
    const newKey = newPrefix.toUpperCase().slice(0, 1);
    
    // 1. ตรวจสอบซ้ำ
    if (this.displayQueue.lanes[newKey] && newKey !== oldKey) {
      alert("ชื่อโซนซ้ำ!");
      this.displayQueue.lanes[oldKey].prefix = oldKey; // รีเซ็ต
      return;
    }

    // 2. ถ้าคีย์เดิมกับคีย์ใหม่เหมือนกัน ไม่ต้องทำอะไร
    if (newKey === oldKey) return;

    // 3. สร้าง Object ใหม่ที่เรียงลำดับเดิมเป๊ะๆ
    const newLanes = {};
    Object.keys(this.displayQueue.lanes).forEach(key => {
      if (key === oldKey) {
        // ใส่ข้อมูลใหม่เข้าไปแทนที่คีย์เดิม
        newLanes[newKey] = { ...this.displayQueue.lanes[oldKey], prefix: newKey };
      } else {
        // ใส่ข้อมูลเดิมเข้าไป
        newLanes[key] = this.displayQueue.lanes[key];
      }
    });

    // 4. แทนที่ Object เดิมด้วย Object ใหม่ที่เรียงลำดับเรียบร้อยแล้ว
    this.displayQueue.lanes = newLanes;
    this.isDirty = true;
  },
  async removeLane(laneKey) {
    // 1. ตรวจสอบก่อนว่าโซนนี้มีอยู่จริงใน Database หรือไม่
    // วิธีเช็ค: ถ้าเราเก็บข้อมูลโซนที่โหลดมาตอนแรกไว้ในตัวแปรแยก (เช่น originalLanes) 
    
    // สมมติว่าคุณต้องการเช็คจาก displayQueue.lanes ณ ปัจจุบัน
    // เราสามารถเพิ่ม Logic การเช็คว่า key นี้มีข้อมูลที่สอดคล้องกับค่าที่โหลดมาหรือไม่
    // แต่ถ้าให้ง่ายที่สุด ให้เช็คว่า "lane นี้ถูกบันทึกไปแล้วหรือยัง"
    // const isNewLane = !this.isLaneSaved(laneKey); // สร้างฟังก์ชันช่วยเช็ค

    // if (!isNewLane) {
    //   try {
    //     await pos({
    //       method: 'post',
    //       url: '/api/V3.0/queue/customer/clear',
    //       headers: { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId) },
    //       data: { shopObjectId: this.shopObjectId, lane: laneKey }
    //     });
    //   } catch (err) {
    //     console.error("Delete Error (API Call):", err);
    //     return; 
    //   }
    // }
    
    this.$delete(this.displayQueue.lanes, laneKey);
    
    this.isDirty = true;
  },
  isLaneSaved(laneKey) {
    // หาก laneKey นี้ไม่ได้อยู่ในข้อมูลที่โหลดมาครั้งแรก ให้ถือว่าเป็นของใหม่
    // คุณอาจต้องเก็บข้อมูล lanes ที่โหลดมาตอนแรกไว้ในตัวแปรแยก เช่น originalLanes
    return !!(this.originalLanes && this.originalLanes[laneKey]);
  },

  addLane(newLaneData) {
    // ตรวจสอบเงื่อนไขก่อนเพิ่ม
    if (Object.keys(this.displayQueue.lanes).length >= 6) return;
    
    // ใช้ $set เพื่อให้ Vue ตรวจพบการเพิ่ม key ใหม่ใน Object
    this.$set(this.displayQueue.lanes, newLaneData.prefix, {
      prefix: newLaneData.prefix,
      min: newLaneData.min,
      max: newLaneData.max
    });
  },
  // ======================
  // BANNER ACTIONS
  // ======================
  async saveBannerLocal() {
    if (!this.isModalDirty) return; // บันทึกได้กรณีมีการแก้ไขเท่านั้น
    this.loadingSaveimg = false;
    try {
      let finalImg = null;
      if (this.currentImg) {
        // จำกัด 2MB และรักษาสัดส่วน
        finalImg = await this.resizeImage(this.currentImg, 2);
      }

      this.$set(
        this.banners[this.currentType],
        this.currentIndex,
        finalImg
      );

      this.isDirty = true;
      this.additionalModal = false;
    } catch (err) {
      console.error('Save Banner Error:', err);
    } finally {
      this.loadingSaveimg = true;
    }
  },
  async getImageURL() {
      this.progressValue = 50
      if (!this.localCoverImage.startsWith("https://firebasestorage")) {
          let ext = mime.getExtension(this.localCoverImage);
          if (ext == null) {
              this.isload = false;
          } else {
              const ownerUID = this.uid
              const directoryPath = 'resources/' + ownerUID + '/resources/coverImageKiosk'
              let imagePath = await uploadImage.onUpload2(directoryPath, this.localCoverImage)
              this.localCoverImage = imagePath
              if (!this.localCoverImage.startsWith("https://firebasestorage")) {
                  this.loginAgainModal = true
              } else {
                  this.loginAgainModal = false
              }
          }
      }
      for (let i = 0; i < this.items.length; i++) {
          if (this.localBannerImage[i] !== null && !this.localBannerImage[i].startsWith("https://firebasestorage")) {
              let ext = mime.getExtension(this.localBannerImage[i]);
              if (ext == null) {
                  this.isload = false;
              } else {
                  const imageName = util.generateFilename('.' + ext)
                  const ownerUID = this.uid
                  const directoryPath = 'resources/' + ownerUID + '/resources/banner/kiosk/' + imageName
                  let imagePath = await uploadImage.onUpload2(directoryPath, this.localBannerImage[i])
                  if (!imagePath.startsWith("https://firebasestorage")) {
                      this.loginAgainModal = true
                  } else {
                      this.loginAgainModal = false
                      this.setImagePathAtIndex(i, imagePath);
                  }
              }
          }
      }
  },
  async getImageURLSaver() {
      this.progressValue = 25
      this.progressText = this.$i18n.t('imageUploading')
      for (let i = 0; i < this.localSaverImage.length; i++) {
          if (this.localSaverImage[i]) {
              if (this.localSaverImage[i] !== null && !this.localSaverImage[i].startsWith("https://firebasestorage")) {
                  let ext = mime.getExtension(this.localSaverImage[i]);
                  if (ext == null) {
                      this.isload = false;
                  } else {
                      const imageName = util.generateFilename('.' + ext)
                      const ownerUID = this.uid
                      const directoryPath = 'resources/' + ownerUID + '/resources/saver/kiosk/' + imageName
                      let imagePath = await uploadImage.onUpload2(directoryPath, this.localSaverImage[i])
                      if (!imagePath.startsWith("https://firebasestorage")) {
                          this.loginAgainModal = true
                      } else {
                          this.loginAgainModal = false
                          this.saver.push(imagePath)
                      }
                  }
              } else if (this.localSaverImage[i].startsWith("https://firebasestorage")) {
                  this.saver.push(this.localSaverImage[i])
              }
          }
      }
  },
  async getOrderShopSetting() {
    const uid = localStorage.getItem('shopsUid');
    let params = { shopObjectId: this.shopObjectId };

    try {
        const res = await pos({
            method: 'get',
            url: '/api/v3.0/shop/ordershopsetting',
            params: params,
            headers: { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId) }
        });

        // ตรวจสอบว่ามีข้อมูลส่งกลับมาจริงหรือไม่
        const rootData = res?.data?.data; 
        if (!rootData) {
            console.warn('ไม่พบข้อมูลการตั้งค่าร้านค้า');
            return;
        }

        // ใช้ Optional Chaining ป้องกัน undefined
        const config = rootData.displayQueue || {}; 
        
        // Mapping ข้อมูลหลักของร้าน
        this.shopName = rootData.greetingMessage?.[0] || 'SilomPOS Cafe';
        
        // Mapping การตั้งค่าหน้าจอแสดงคิว (ถ้าไม่มีให้ใช้ค่า Default)
        this.selectedTheme = config.themeColor || '#29B46B';
        this.voiceLanguages = config.ttsLanguage || [];
        this.layoutType = config.screenOrientation === 1 ? 'portrait' : 'landscape';

        // จัดการเรื่อง Banner
        if (config.banners) {
            this.banners.landscape = { ...this.banners.landscape, ...(config.banners.landscape || {}) };
            this.banners.portrait = { ...this.banners.portrait, ...(config.banners.portrait || {}) };
        }

        this.isVideoBanner = config.isVideoBanner || false
        this.videoBanner = {
          landscape: config.videoBanner?.landscape || '',
          portrait: config.videoBanner?.portrait || ''
        };

        // เรียก loadDisplayQueue โดยส่งข้อมูลเข้าไปโดยตรงเพื่อความปลอดภัย
        this.loadDisplayQueue(rootData); 

    } catch (error) {
        console.error('Error in getOrderShopSetting:', error);
    }
    this.isDirty = false;
  },
  async saveCoverImageLocal() {
      this.loadingSaveimg = false
      let resizedImage = await this.resizeImage(this.currentImg)
      this.localCoverImage = resizedImage
      this.currentImg = ''
      this.coverImageModal = false
      this.loadingSaveimg = true
      // this.getImageURL2()
  },
  async deleteLocalImg() {
  if (this.onBanner) {
      if (this.localBannerImage[this.currentButton] !== undefined && this.localBannerImage[this.currentButton] !== null) {
          if (this.localBannerImage[this.currentButton].startsWith("https://firebasestorage")) {
              this.imagePathDeleted.push(this.localBannerImage[this.currentButton])
          }

      }
      this.action = ''
      this.bannerDataInputBox = ''
      this.localBannerImage[this.currentButton] = null
      this.items[this.currentButton] = null
      this.currentImg = ''
      this.localBannerImage = this.localBannerImage.filter(localBannerImage => localBannerImage !== null);
      this.items = this.items.filter(item => item !== null);
      this.currentButton = null
      this.additionalModal = false
  } else {
      if (this.localSaverImage[this.currentButton] !== undefined && this.localSaverImage[this.currentButton] !== null) {
          if (this.localSaverImage[this.currentButton].startsWith("https://firebasestorage")) {
              this.imagePathDeleted.push(this.localSaverImage[this.currentButton])
          }

      }
      this.localSaverImage[this.currentButton] = null
      this.currentImg = ''
      this.localSaverImage = this.localSaverImage.filter(localSaverImage => localSaverImage !== null);
      this.currentButton = null
      this.additionalModal = false
    }
  },
  loadDisplayQueue(data) {
    const dq = data.displayQueue || {}

    // logo
    this.logoImage = {
      landscape: dq.logo?.landscape || "",
      portrait: dq.logo?.portrait || ""
    }

    // ✅ banners (KEEP AS OBJECT)
    this.banners.landscape = dq.banners?.landscape || {
      "1": null,
      "2": null,
      "3": null,
      "4": null,
      "5": null
    }

    this.banners.portrait = dq.banners?.portrait || {
      "1": null,
      "2": null,
      "3": null,
      "4": null,
      "5": null
    }

    // layout
    this.layoutType = dq.screenOrientation === 0 ? "landscape" : "portrait"

    // language
    this.displayLanguage = dq.textLanguage || "TH"

    // voice
    this.voiceLanguages = dq.ttsLanguage || []
    this.enableVoice = this.voiceLanguages.length > 0

    // theme
    this.selectedTheme = dq.themeColor || "#29B46B"

    // speed
    this.bannerSpeed = dq.bannersDuration || 10

    this.displayQueue.mode = dq.mode || "ORDER";
    this.displayQueue.postfixLength = dq.postfixLength || 2;
    this.displayQueue.lanes = dq.lanes || {};
    this.originalLanes = dq.lanes ? JSON.parse(JSON.stringify(dq.lanes)) : {};
    this.displayQueue.information = dq.information || "";
  },
  normalizeBanner(obj) {
    const result = { "1": null, "2": null, "3": null, "4": null, "5": null }
    return { ...result, ...(obj || {}) }
  },
  convertBannerArrayToObject(arr) {
    const obj = {}

    arr.forEach((item, index) => {
      if (item) {
        obj[(index + 1).toString()] = item
      }
    })

    return obj
  },
  buildPayload() {
    return {
      displayQueue: {
        logo: {
          landscape: this.logoImage.landscape,
          portrait: this.logoImage.portrait
        },

        banners: {
          landscape: this.convertBannerArrayToObject(this.banners.landscape),
          portrait: this.convertBannerArrayToObject(this.banners.portrait)
        },

        screenOrientation: this.layoutType === "landscape" ? 0 : 1,

        bannersDuration: this.bannerSpeed,

        themeColor: this.selectedTheme,

        textLanguage: this.displayLanguage,

        ttsLanguage: this.enableVoice ? this.voiceLanguages : []
      }
    }
  }
 },
};
</script>
<style scoped>
/* Container & Layout */
.queue-config-container {
  /* background-color: #f8fafc; */
  min-height: 100vh;
  /* font-family: 'Inter', 'Kanit', sans-serif; */
}

.config-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 5px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.section-title {
  font-weight: 700;
  color: #1e293b;
  display: flex;
  align-items: center;
}

/* Logo Upload Customization */
.logo-placeholder {
  background: #f1f5f9;
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  padding: 0;
  overflow: hidden;
}

.logo-placeholder:hover {
  border-color: #29b46b;
  background: #ecfdf5;
}

.logo-placeholder.landscape { width: 140px; height: 90px; }
.logo-placeholder.portrait { width: 90px; height: 120px; }
.logo-placeholder img { width: 100%; height: 100%; object-fit: contain; }

/* Theme Color Palette */
.color-palette-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.color-option-btn {
  width: 34px;
  height: 34px;
  border-radius: 50% !important;
  padding: 0;
  border: 2px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;
}

.color-option-btn.active {
  transform: scale(1.15);
  border-color: #e2e8f0;
}

.custom-color-label {
  width: 37px;
  height: 37px;
  border-radius: 50% !important;
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 2px solid #e2e8f0;
  color: #fff;
  transition: transform 0.2s;
  text-shadow: 0 1px 2px rgba(0,0,0,0.3);
}

.color-input-hidden {
  display: none;
}

/* Segmented Control (Layout/Lang) */
.segmented-control {
  display: flex;
  background: #f1f5f9;
  padding: 4px;
  border-radius: 12px;
  margin-top: 8px;
}

.control-item {
  flex: 1;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  border-radius: 8px;
  font-weight: 600;
  color: #64748b;
  transition: all 0.2s;
}

.control-item.active {
  background: #ffffff;
  color: #29b46b;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}
/* สถานะเมื่อต้องการปิดการใช้งาน (Disabled) */
.control-item.disabled {
  cursor: not-allowed;
  opacity: 0.6;
  background: transparent;
  color: #94a3b8;
}

/* เพิ่มให้แน่ใจว่าเมื่อ hover แล้วไม่มีการตอบสนอง */
.control-item.disabled:hover {
  background: transparent;
  box-shadow: none;
}

/* Voice Config */
.voice-lang-card {
  position: relative;
  background: #fff;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.2s;
}

.voice-lang-card.selected {
  border-color: #29b46b;
  background: #f0fdf4;
}

.lang-flag { width: 24px; height: 24px; border-radius: 4px; }

.order-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #29b46b;
  color: #fff;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  border: 2px solid #fff;
}

/* Banner Grids */
.banner-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
}

.banner-box-small {
  width: 100%;
  aspect-ratio: 1;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  padding: 0;
  overflow: hidden;
}

.banner-box-small.landscape { aspect-ratio: 16/9; }
.banner-box-small img { width: 100%; height: 100%; object-fit: cover; }

/* Sticky Side Panel */
.sticky-side-panel {
  position: sticky;
  top: 2rem;
}

.status-card {
  background: #fff;
  border-radius: 5px;
  border: 1px solid #e2e8f0;
}

.save-btn-large {
  border-radius: 5px;
  font-weight: 700;
  padding: 12px;
  transition: all 0.3s;
}

/* Animations */
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

/* Dropzone */
.upload-dropzone {
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  padding: 2rem;
  cursor: pointer;
  transition: 0.2s;
}

.upload-dropzone:hover {
  background: #f8fafc;
  border-color: #29b46b;
}

/* Modern Select */
.modern-select {
  border-radius: 10px;
  height: 45px !important;
  border: 1px solid #e2e8f0;
}
/* Preview Background */
.preview-container-bg {
  background: #334155; /* สีเข้มเพื่อให้ Mockup เด่น */
  min-height: 300px;
}

/* Mockup Display Base */
.mockup-display {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  color: white; /* เลขคิวส่วนใหญ่เป็นสีขาวตามที่คุณระบุ */
}

/* แนวนอน (TV Style) */
.mockup-display.landscape {
  width: 100%;
  aspect-ratio: 16 / 9;
}

/* แนวตั้ง (Tablet Style) */
.mockup-display.portrait {
  width: 200px;
  aspect-ratio: 9 / 16;
}

/* Mockup Elements */
.mockup-logo {
  padding: 10px;
  height: 40px;
  display: flex;
  align-items: center;
}
.mockup-logo img {
  height: 100%;
  object-fit: contain;
}
.mockup-logo-placeholder {
  width: 30px;
  height: 30px;
  background: rgba(255,255,255,0.2);
  border-radius: 4px;
  font-size: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mockup-content {
  flex: 1;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.q-label { font-size: 0.6rem; opacity: 0.8; }
.q-number { font-size: 2rem; font-weight: bold; line-height: 1; }
.q-waiting { font-size: 0.8rem; margin: 5px; opacity: 0.6; }

.mockup-banner {
  /* background: rgba(0,0,0,0.1);  */
  height: 25%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  border-top: 1px solid rgba(255,255,255,0.1);
}

/* Portrait Layout Adjustment */
.portrait .mockup-content {
  padding-top: 40px;
}
.portrait .q-number { font-size: 1.5rem; }
/* Monitor Frame */
.monitor-mockup {
  background: #f4f7f6;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 40px rgba(0,0,0,0.5);
  overflow: hidden;
  position: relative;
  transition: all 0.5s ease;
}

.monitor-mockup.landscape { width: 480px; height: 270px; }
.monitor-mockup.portrait { width: 220px; height: 380px; }

/* Top Bar */
.mockup-top-bar {
  padding: 6px 12px;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 10px;
}
.mockup-logo-img { height: 14px; width: 14px; object-fit: contain; }

/* Grid System */
.mockup-main-grid {
  display: flex;
  flex: 1;
  padding: 8px;
  gap: 8px;
  overflow: hidden;
}
.landscape .mockup-main-grid { flex-direction: row; }
.portrait .mockup-main-grid { flex-direction: column; }

.queue-section { flex: 2; display: flex; flex-direction: column; }
.ad-section { flex: 1.2; background: #000; border-radius: 6px; overflow: hidden; position: relative; }

/* Queue Blocks */
.q-block { border: 1px solid #ddd; border-radius: 6px; overflow: hidden; background: #fff; }
.q-header { padding: 4px 8px; font-size: 9px; color: white; display: flex; justify-content: space-between; }
.q-header.blue { background: #6da5e0; }
.q-header.orange { background: #f4b459; }

.q-card-item {
  margin: 6px;
  padding: 6px;
  border: 1px solid #eee;
  border-left: 4px solid #6da5e0;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}
.q-id { font-size: 14px; font-weight: bold; color: #333; }
.q-sub { font-size: 8px; color: #888; }
.q-icon-box { width: 20px; height: 20px; background: #6da5e0; color: white; border-radius: 3px; display: flex; align-items: center; justify-content: center; font-size: 10px; }

/* Ad Styling */
.ad-placeholder { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; }
.ad-dots {
  position: absolute; bottom: 5px; width: 100%;
  display: flex; justify-content: center; gap: 3px;
}
.ad-dots span { width: 4px; height: 4px; background: rgba(255,255,255,0.3); border-radius: 50%; }
.ad-dots span.active { width: 10px; border-radius: 4px; }

/* Footer */
.mockup-footer {
  padding: 4px 10px;
  text-align: right;
  font-size: 7px;
  color: #aaa;
  background: #fff;
  border-top: 1px solid #eee;
}
/* พื้นหลังส่วน Preview */
.preview-body-container {
  min-height: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-image: radial-gradient(#444 1px, transparent 1px); */
  background-size: 20px 20px;
}

/* ตัวเครื่อง Monitor */
.monitor-mockup {
  background: #f1f5f9;
  box-shadow: 0 30px 60px -12px rgba(0,0,0,0.5);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}
.monitor-mockup.landscape { width: 640px; height: 360px; }
.monitor-mockup.portrait { width: 260px; height: 460px; }

/* Top Bar */
.mockup-top-nav {
  padding: 8px 15px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
}
.mockup-logo-img { height: 18px; width: 18px; border-radius: 4px; object-fit: cover; }

/* Content Grid */
.mockup-content-area {
  display: flex;
  flex: 1;
  overflow: hidden;
  padding: 10px;
  gap: 10px;
}
.landscape .mockup-content-area { flex-direction: row; }
.portrait .mockup-content-area { flex-direction: column; }

.queue-display-container { flex: 1.5; display: flex; flex-direction: column; gap: 8px; }
.ads-display-container { flex: 1; background: #fff; border-radius: 8px; overflow: hidden; }

/* Section Header (Blue & Orange) */
.q-section { border-radius: 8px; background: #fff; overflow: hidden; border: 1px solid #e2e8f0; }
.q-section-header { padding: 5px 12px; font-size: 10px; font-weight: bold; color: #fff; display: flex; justify-content: space-between; }
.q-section-header-call { padding: 5px 8px; font-size: 10px; font-weight: bold; color: #000; display: flex; justify-content: space-between; }
.bg-blue-status { background: #5ea1e4; } /* สีตามรูป */
.bg-orange-status { background: #f1ad4d; }

/* Ticket Design */
.q-list-scroll { padding: 8px; display: flex; flex-direction: column; gap: 6px; }
.q-list-scroll.grid-mode { display: grid; grid-template-columns: 1fr 1fr; }

.q-ticket-mini {
  background: #fff;
  border: 1px solid #edf2f7;
  border-left: 4px solid #5ea1e4;
  border-radius: 6px;
  padding: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.03);
}
.q-ticket-mini.border-orange { border-left-color: #f1ad4d; }
.q-ticket-id { font-size: 13px; font-weight: 800; color: #2d3748; }
.q-ticket-meta { font-size: 8px; color: #a0aec0; margin-left: auto; }
.q-ticket-icon { width: 22px; height: 22px; background: #ebf4ff;  border-radius: 4px; display: flex; align-items: center; justify-content: center; font-size: 10px; }
.q-ticket-icon.orange { background: #fffaf0; color: #f1ad4d; }

/* Ad Mockup */
.ad-mock-image { height: 100%; position: relative; }
.ad-mock-image img { width: 100%; height: 100%; object-fit: cover; }
.ad-pagination { position: absolute; bottom: 8px; width: 100%; display: flex; justify-content: center; gap: 4px; }
.dot { width: 4px; height: 4px; background: rgba(255,255,255,0.4); border-radius: 50%; }
.dot.active { width: 12px; border-radius: 4px; transition: all 0.3s; }

/* Footer */
.mockup-footer-brand { padding: 5px 12px; text-align: right; font-size: 8px; color: #cbd5e1; background: #fff; border-top: 1px solid #f1f5f9; }
/* จัดการรูปภาพใน Carousel Preview */
.obj-fit-cover {
  width: 100%;
  height: 100%;
  object-fit: cover; /* ให้รูปเต็มพื้นที่โดยไม่เสียสัดส่วน */
}

.ad-placeholder-empty {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #1a1a1a;
  color: #4a5568;
}

/* ปรับความสูงของ Carousel ให้เต็มพื้นที่ Container */
.VueCarousel {
  height: 100%;
}
.VueCarousel-wrapper, .VueCarousel-inner, .VueCarousel-slide {
  height: 100% !important;
}
/* --- 1. Monitor Mockup Base (Portrait) --- */
.monitor-mockup.portrait {
  width: 320px; /* ปรับความกว้างจำลองสำหรับ Tablet */
  height: 540px; /* อัตราส่วนแนวตั้ง */
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 24px;
  border: 8px solid #333; /* ขอบตัวเครื่อง */
  overflow: hidden;
  position: relative;
  transition: all 0.3s ease;
}

/* --- 2. Portrait Banner Top (ส่วนแบนเนอร์ด้านบน) --- */
.portrait-banner-top {
  width: auto;
  height: 120px; /* กำหนดความสูงแบนเนอร์ในโหมดแนวตั้ง */
  background: #2a2a2a;
  overflow: hidden;
}

.portrait-banner-top .mockup-img-fluid {
  width: 100%;
  height: 100%;
  object-fit: cover; /* ให้รูปแบนเนอร์ไม่เบี้ยว */
}

/* --- 3. Content Area Layout Adjustment --- */
.monitor-mockup.portrait .mockup-content-area {
  flex-direction: column; /* จัด Queue ให้เรียงลงด้านล่างแบนเนอร์ */
  height: calc(100% - 180px - 50px); /* หักความสูง Banner และ Nav */
  padding: 10px;
  overflow-y: auto;
}

/* --- 4. Queue Section inside Portrait --- */
.monitor-mockup.portrait .queue-display-container {
  width: 100%;
  display: block;
}

.monitor-mockup.portrait .q-list-scroll {
  display: flex;
  flex-direction: column; /* คิวเรียงลงมาหนึ่งแถวเต็มในแนวตั้ง */
  gap: 8px;
}

/* --- 5. Queue Ticket Styling (Portrait) --- */
.monitor-mockup.portrait .q-ticket-mini {
  width: 100%; /* ให้บัตรคิวกว้างเต็มจอ Tablet */
  display: flex;
  align-items: center;
  padding: 12px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.monitor-mockup.portrait .q-ticket-id {
  font-size: 16px; /* ปรับขนาดตัวเลขคิวให้เด่นชัด */
  margin-left: 10px;
}

/* --- 6. Placeholder for empty banner --- */
.placeholder-banner-mini {
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, #4a5568, #2d3748);
}

.placeholder-banner-mini i {
  font-size: 40px;
  opacity: 0.3;
}
/* ขยายขนาด Switch ให้กดง่ายขึ้นบน Tablet */
.custom-switch-md .custom-control-label::before {
  height: 1.5rem;
  width: 2.75rem;
  border-radius: 1rem;
  cursor: pointer;
  border: 2px solid #dee2e6;
  background-color: #e9ecef;
  transition: all 0.3s ease;
}

.custom-switch-md .custom-control-label::after {
  width: calc(1.5rem - 8px);
  height: calc(1.5rem - 8px);
  background-color: #adb5bd;
  border-radius: 1rem;
  top: calc(0.25rem + 2px);
  left: calc(-2.25rem + 4px);
  transition: all 0.3s ease;
}

/* เมื่อเปิดใช้งาน (Active) */
.custom-control-input:checked ~ .custom-control-label::before {
  background-color: #2eb85c !important; /* สีเขียว Success */
  border-color: #2eb85c !important;
}

.custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff !important;
  transform: translateX(1.25rem); /* เลื่อนจุดขาวไปทางขวา */
}

/* ปรับระยะห่างและฟอนต์ */
.voice-switch-wrapper {
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #edf2f7;
}

.custom-control-label {
  padding-left: 12px;
  padding-top: 2px;
  cursor: pointer;
  user-select: none;
}
/* ======================
   COLOR PICKER
====================== */
.theme-color-btn {
 width: 40px;
 aspect-ratio: 1/1;
 border: none;
 border-radius: 8px;
 margin-right: 6px;
 margin-bottom: 6px;
 cursor: pointer;
}

.theme-color-btn.active {
 border: 3px solid #ccc;
 transform: scale(1.1);
}
.ad-pagination-dots-custom {
  position: absolute;
  bottom: 15px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 6px;
  z-index: 10; /* มั่นใจว่าลอยทับรูป */
}

.dot-item {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  transition: all 0.3s ease;
  display: inline-block;
}

.dot-item.active {
  width: 20px; /* ทำจุดที่เลือกให้ยาวขึ้นแบบ Pill shape (ถ้าชอบ) */
  border-radius: 10px;
}
.mockup-img-portrait-fixed {
  width: 100%;
  height: 180px; /* ต้องเท่ากับความสูงที่ตั้งไว้ใน carousel */
  object-fit: cover; /* ครอบรูปให้เต็มพื้นที่ */
  display: block;
}

/* ป้องกัน Carousel คำนวณความสูงผิดพลาด */
.portrait-banner-top .VueCarousel,
.portrait-banner-top .VueCarousel-wrapper,
.portrait-banner-top .VueCarousel-inner,
.portrait-banner-top .VueCarousel-slide {
  height: 100% !important;
}

/* จัดการส่วนพื้นที่เนื้อหาด้านล่างให้เลื่อนได้ถ้าสูงเกิน */
.mockup-content-area {
  flex: 1;
  overflow-y: auto;
}
/* Container หลักที่คุมความสูงแบนเนอร์ */
.portrait-banner-top {
  width: 100%;
  /* 🔥 กำหนดสัดส่วนตายตัว 1080x300 */
  aspect-ratio: 1080 / 300; 
  background-color: #f8f9fa;
  overflow: hidden;
}

/* ตั้งค่า Carousel ให้สูงเต็ม 300px */
.mockup-banner-carousel {
  width: 100%;
  height: 100% !important;
}

/* ตัว Slide และ Wrapper ของรูป */
.banner-img-wrapper {
  width: 100%;
  height: 300px; /* บังคับความสูง */
  display: block;
}

.obj-fit-cover {
  width: 100% !important;  /* ให้กว้างเต็ม Layout */
  height: auto;
  
  /* 🔥 หัวใจสำคัญ: ทำให้รูปไม่เบี้ยวแม้สัดส่วนภาพจริงจะไม่ใช่ 1080x300 */
  object-fit: cover; 
  object-position: center;
}

/* เจาะเข้าไปแก้สไตล์ภายในของ VueCarousel */
::v-deep .VueCarousel-wrapper,
::v-deep .VueCarousel-inner,
::v-deep .VueCarousel-slide {
  height: 300px !important;
}
/* 1. Container หลัก: ล็อกสัดส่วน 1080:300 */
.portrait-banner-top {
  width: 100%;
  /* 🔥 กำหนดสัดส่วนอัตราส่วน (3.6:1) */
  aspect-ratio: 1080 / 300; 
  background-color: #000; /* พื้นหลังสีดำกันขอบว่าง */
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 2. Carousel: ให้สูงและกว้างเต็ม Container */
.mockup-banner-carousel {
  width: 100%;
  height: 100% !important;
}

/* 3. Wrapper และ Image */
.banner-img-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.obj-fit-cover {
  /* 🔥 ล็อกความสูงให้เต็มพื้นที่ที่ Ratio กำหนด */
  height: 100% !important;
  width: 100% !important; 
  
  /* 🔥 จัดการรูปภาพ: 
     - cover: ขยายรูปให้เต็มพื้นที่สัดส่วน 1080x300 (ถ้ากว้างเกินจะถูกตัดด้านข้างออก)
     - center: รักษาเนื้อหาตรงกลางภาพไว้
  */
  object-fit: cover; 
  object-position: center;
}

/* เจาะจงแก้ภายใน VueCarousel ให้รักษาสัดส่วน */
::v-deep .VueCarousel-wrapper,
::v-deep .VueCarousel-inner,
::v-deep .VueCarousel-slide {
  height: 100% !important;
}
.monitor-mockup {
  background: #f1f5f9;
  box-shadow: 0 30px 60px -12px rgba(0,0,0,0.5);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  margin: 0 auto; /* จัดกลาง */
  transition: all 0.4s ease;
}

/* 🔥 แนวนอน (Landscape): ปรับความกว้างให้เต็ม 100% ของคอลัมน์ฝั่งขวา */
.monitor-mockup.landscape {
  width: 100%; 
  max-width: 640px; /* จำกัดขนาดสูงสุดไว้ไม่ให้ใหญ่จนเกินไป */
  aspect-ratio: 16 / 9; /* รักษาสัดส่วนจอ TV เสมอ */
  height: auto !important;
}

/* 🔥 แนวตั้ง (Portrait): ปรับสัดส่วนให้เหมือน Tablet/Smartphone */
.monitor-mockup.portrait {
  width: 70%; /* ให้แคบลงกว่าแนวนอนเพื่อความสมจริง */
  max-width: 320px;
  aspect-ratio: 9 / 16;
  height: auto !important;
}

/* ปรับให้เนื้อหาภายในยืดหยุ่นตามตัวเครื่อง */
.mockup-content-area {
  display: flex;
  flex: 1;
  overflow: hidden;
  padding: 1%; /* ใช้ % แทน px เพื่อความยืดหยุ่น */
  gap: 10px;
}
/* คอนเทนเนอร์กรณีใช้หน้าว่างสีขาว */
.placeholder-banner-default-logo,
.ad-placeholder-default-logo {
  background-color: #ffffff !important; /* บังคับพื้นหลังขาว */
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
}

/* จัดสัดส่วนโลโก้ร้านให้อยู่กึ่งกลางพอดี */
.default-centered-logo {
  max-width: 60%;         /* กำหนดขนาดความกว้างสูงสุด */
  max-height: 60%;        /* กำหนดขนาดความสูงสูงสุด */
  object-fit: contain;     /* รักษาสัดส่วนดั้งเดิมของโลโก้ไว้ ไม่ให้เบี้ยว */
  display: block;
}

/* กรณีรูปภาพมีขนาดเล็กกว่าพื้นที่ ให้คงความละเอียดไว้ */
.opacity-5 {
  opacity: 0.5;
}
.customer-queue-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
  padding: 10px;
}

.lane-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);
}

.info-ticker {
  background: #000;
  color: #fff;
  padding: 8px;
  font-size: 14px;
  margin-top: auto; /* ดันลงล่างสุด */
  overflow: hidden;
}


/* Zone Card */
.zone-card {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 10px;
  padding: 12px;
  transition: all 0.2s;
}

.zone-card:hover {
  border-color: #cbd5e0;
}

/* Prefix Badge */
.prefix-badge {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 8px;
  font-weight: bold;
  text-align: center;
  min-width: 45px;
  color: #2d3748;
}

/* Form Controls */
.form-control-sm {
  height: 32px;
  font-size: 0.85rem;
}

.form-label {
  margin-bottom: 0.25rem;
  font-weight: 500;
}

/* Buttons */
.btn-outline-primary {
  border-color: #29B46B;
  color: #29B46B;
}

.btn-outline-primary:hover {
  background-color: #29B46B;
  color: white;
}

.btn-link.text-danger {
  font-size: 1.2rem;
  text-decoration: none;
}

/* Responsive Grid */
@media (max-width: 768px) {
  .col-md-6 {
    width: 100%;
  }
}
.lane-container {
  display: flex;
  align-items: center; /* ปรับทุกอย่างให้อยู่กึ่งกลางในแนวตั้ง */
  gap: 10px;           /* ปรับระยะห่างระหว่างช่อง */
}
/* สำหรับ Preview ในหน้าตั้งค่า */
.video-preview-wrapper {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
  overflow: hidden;
  background-color: #000;
}

.video-preview-wrapper .v-lazy-youtube {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.video-preview-wrapper iframe {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>